import TextLink from "@shared/v2/TextLink";
import Button from "@shared/v2/Button";
import { AreaProCustomv6 } from "@icons/index";
import AiProvider from "@shared/AiAssistant/AiProvider";
import { lazyAiComponent } from "@shared/AiAssistant/lazyAiComponent";
import CollapsibleElement from "./CollapsibleElement";
import { useCurrentUser } from "../../reducers/layoutReducer/selectors";

const AreaProInsightButtonGroup = lazyAiComponent("AreaProInsightButtonGroup");

const AreaPro = ({ addresses }) => {
  const currentUser = useCurrentUser();
  const areaProLink = `https://app.areapro.com/auto?email=${currentUser.email}`;
  const openLink = () => {
    window.open(areaProLink, "_blank");
  };

  return (
    <CollapsibleElement
      title="AreaPro"
      containerClassName="tw-px-[20px] tw-py-[16px] !tw-shadow-none"
      chevronPlacementLeft={false}
      chevronClassName=""
    >
      <AiProvider>
        {addresses.length > 0 ? (
          <div>
            <div className="tw-mb-[14px] tw-mt-[16px] tw-text-12d">
              Access easy-to-understand market stats for this lead's address(es) with{" "}
              <TextLink className="tw-text-[12px]" href={areaProLink} target="_blank">
                AreaPro
              </TextLink>
              .
            </div>
            <AreaProInsightButtonGroup addresses={addresses} containerStyle={{ gap: "10px" }} />
          </div>
        ) : (
          <div className="tw-mt-[12px] tw-text-12d">
            Save an address for this lead to get market stats, or visit{" "}
            <TextLink className="tw-text-[12px]" href={areaProLink} target="_blank">
              AreaPro
            </TextLink>{" "}
            for custom areas.
            <Button
              onClick={openLink}
              schema="secondary"
              size="medium"
              className={`tw-mt-[12px] tw-text-[11px] tw-leading-[16px] tw-justify-center tw-w-[100%] !tw-rounded-8px tw-flex tw-gap-6px tw-items-center`}
            >
              <AreaProCustomv6 size="m" /> GO TO AREAPRO
            </Button>
          </div>
        )}
      </AiProvider>
    </CollapsibleElement>
  );
};

export default AreaPro;
